import { render, staticRenderFns } from "./ListJSON.vue?vue&type=template&id=aa4ccf0c"
import script from "./ListJSON.vue?vue&type=script&lang=js"
export * from "./ListJSON.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports